import React from 'react'

import { setSupportModalOpen, useSupportModalState } from '../../lib/support/modal/state'
import { TicketForm } from './TicketForm'

export const SupportTicketModal: React.VFC = () => {
  const supportModalState = useSupportModalState()
  if (!supportModalState) {
    return null
  }
  return <TicketForm isOpen={supportModalState} handleClose={() => setSupportModalOpen(false)} />
}
